import classNames from 'classnames';
import * as React from 'react';
import { FiChevronRight, FiX } from 'react-icons/fi';
import { COLLAPSED_COLUMN_WIDTH, EXPANDED_COLUMN_WIDTH } from '../../layout';
import { Release, Task } from '../../types';
import { getMonthName } from '../../utils/dateUtils';
import { pluralize } from '../../utils/stringUtils';

type HeaderColumnProps = {
  release: Release;
  numberOfTasks: number;
  numberOfSolutions: number;
  isExpanded: boolean;
  toggle: () => void;
};

const HeaderColumn = ({
  release,
  numberOfTasks,
  numberOfSolutions,
  isExpanded,
  toggle,
}: HeaderColumnProps) => {
  const monthName = React.useMemo(() => getMonthName(release.releaseDate), [release.releaseDate]);
  const fullYear = React.useMemo(() => release.releaseDate.getFullYear(), [release.releaseDate]);
  const style: React.CSSProperties = React.useMemo(() => {
    return {
      width: `${isExpanded ? EXPANDED_COLUMN_WIDTH : COLLAPSED_COLUMN_WIDTH}px`
    }
  }, [isExpanded]);

  return (
    <div style={style} className="relative text-center flex-none flex flex-col items-center justify-center h-full transition-width">
      <button
        className={classNames(
          'w-7 h-7 rounded-full bg-gray-800 text-white text-xs font-bold flex items-center justify-center mb-4',
          isExpanded && 'opacity-50'
        )}
        onClick={toggle}
      >
        <FiChevronRight
          className={classNames(
            'w-4 h-4 transition-all -mr-0.5',
            isExpanded ? 'transform rotate-180 mr-0.5' : 'transform rotate-0'
          )}
          strokeWidth={3.5}
        />
      </button>
      <div
        className={classNames(
          'absolute pl-3 pb-4 left-0 bottom-0 text-center w-32 transition-opacity',
          isExpanded ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
      >
        <div className="text-4xl font-light">{numberOfTasks}</div>
        <div className="text-xxs uppercase font-bold leading-5">
          {`${pluralize(numberOfTasks, 'sag', 'sager')} i sprintet`}
        </div>
      </div>
      <div
        className={classNames(
          'absolute pr-3 pb-4 right-0 bottom-0 text-center w-32 transition-opacity',
          isExpanded ? 'opacity-100' : 'opacity-0 pointer-events-none'
        )}
      >
        <div className="text-4xl font-light">{numberOfSolutions}</div>
        <div className="text-xxs uppercase font-bold leading-5">
          {pluralize(numberOfSolutions, 'applikation', 'applikationer')}
        </div>
      </div>
      <div className="text-xs uppercase font-bold">{monthName}</div>
      <div className="text-xs uppercase font-bold mb-2">Sprint</div>
      <div>{fullYear}</div>
    </div>
  );
};

export default HeaderColumn;
